import { Button, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalculator } from '@fortawesome/pro-solid-svg-icons'
import { IntroStepProps } from '../../types'

const { Title, Paragraph } = Typography

export const IntroStep = ({ onStart }: IntroStepProps) => {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        width: '100%',
        maxWidth: '600px',
        alignItems: 'center',
        padding: '40px 20px',
        textAlign: 'center'
      }}
    >
      <FontAwesomeIcon
        icon={faCalculator}
        style={{
          fontSize: '64px',
          color: '#ff6b4a'
        }}
      />

      <Title level={2} style={{ margin: 0 }}>
        Let's Build Your Budget
      </Title>

      <Paragraph style={{ fontSize: '16px', maxWidth: '500px', margin: 0 }}>
        We'll ask a few questions about your business to build a budget that helps
        you know your numbers and price with confidence.
      </Paragraph>

      <Space direction="horizontal" size="small" style={{ color: '#666' }}>
        <FontAwesomeIcon icon={faCalculator} style={{ fontSize: '14px' }} />
        <span>Approximate completion time – <strong>Less than 10 minutes</strong></span>
      </Space>

      <Button
        type="primary"
        size="large"
        onClick={onStart}
        style={{
          marginTop: '20px',
          width: '300px',
          height: '48px',
          fontSize: '16px',
          backgroundColor: '#ff6b4a',
          borderColor: '#ff6b4a'
        }}
      >
        Let's Get Started!
      </Button>
    </Space>
  )
}
